import React from 'react';

const FormLeft = ({children, className}) => {
	return <div className={`form-left gap-y-24px flex flex-col ${className}`}>
		{children}
	</div>;
};

export default FormLeft;